import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";


export class Tiles {
  constructor(private $log: Logger, private $utils: Utils) {
    const tiles: NodeListOf<HTMLElement> = document.querySelectorAll('.js-tile');

    tiles?.forEach((tile: HTMLElement) => {
      this.handleTiles(tile);
    });

    window.addEventListener('resize', () => {
      tiles?.forEach(tile => {
        const size = Math.max(tile.clientWidth, tile.clientHeight);
        tile.style.fontSize = (size / 3.5) + 'px';
      });
    });
  }

  private handleTiles(tile: HTMLElement) {
    const width = tile.clientWidth;
    const height = tile.clientHeight;
    const perspective = Math.max(width, height);

    tile.addEventListener('mousemove', (event) => {
      const tileRect = tile.getBoundingClientRect();
      // const x = event.clientX - tileRect.left;
      // const y = event.clientY - tileRect.top;
      const x = event.offsetX;
      const y = event.offsetY;
      const angleY = (width / 2 - x) / width * 10;
      const angleX = (height / 2 - y) * -1 / height * 10;
      const translateX = ((width / 2 - x)) * -1 / width * 10;
      const translateY = ((height / 2 - y)) * -1 / height * 10;


      if (tile) {
        tile.style.perspective = (perspective * 2.5) + 'px';
      }

      tile.style.transform = 'translateZ(4rem) rotateY(' + angleY + 'deg) rotateX(' + angleX + 'deg) translateX(' + translateX + 'px) translateY(' + translateY + 'px)';

      tile.querySelectorAll('img')?.forEach((parallaxContent, layer) => {
        layer++;
        const modifier = -.65;
        parallaxContent.style.transform = 'scale(1.075) translateX(' + (translateX * modifier * layer) + 'px) translateY(' + (translateY * modifier * layer) + 'px)';
      });
    });

    tile.addEventListener('mouseout', () => {
      if (tile) {
        tile.style.perspective = (perspective * 2.5) + 'px';
      }
      tile.style.transform = `rotateX(0deg) rotateY(0deg) translateZ(0px)`;
    });

    const size = Math.max(tile.clientWidth, tile.clientHeight);

    tile.style.fontSize = (size / 3.5) + 'px';
  }
}
